import axios from '../utils/axios'

// // 获取奖金列表
export function getGoodsSimpleList(params = {}) {
  return axios.post('/goods/apiGoodsAh5Service/getGoodsSimpleList', params)
}

export function getGoodsList(params = {}) {
  return axios.post('/goods/apiGoodsAwService/GetGoodsList', params)
}
